import React, { Component } from 'react';
import {ShowIf} from 'components/utils';
import {Link} from 'react-router-dom';

class ConversationItem extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      img: require('assets/images/company/logo.png'),
      name: 'Doanh nghiệp 1',
      address: 'address',
      tel: '+844 233 233'
    };
  }

  render() {
    return (
      <div className="need-offer-business-container"
        onClick={this.props.onClick}
      >
        <div className='need-offer-business-wrap-img'>
          <img src={this.state.img}/>
        </div>
        {this.props.owner && this.props.owner.mainBusiness &&
          <div className='need-offer-business-detail'>
            <p className='need-offer-business-name'>{this.props.owner.mainBusiness.name}</p>
            <div className='content-justify'>
              <p className='m0 p0'>
                <span className='need-offer-business-desc mr25'>Địa chỉ:&nbsp;{this.props.owner.mainBusiness.address}</span>
                <span className='need-offer-business-desc'>Số điện thoại:&nbsp;{this.props.owner.mainBusiness.phone}</span>
              </p>
              <ShowIf condition={false && 10}>
                <p>
                  <Link to={`/my-business/need-offer/something`} className='need-offer-business-link'>
                    14 tin nhắn
                    <i className='fa fa-commenting'/>
                  </Link>
                </p>
              </ShowIf>
            </div>
          </div>
        }
      </div>
    );
  }

}

export default ConversationItem;



// WEBPACK FOOTER //
// ./components/conversations/ConversationItem.jsx